import AppConstants from '../config/app.constants';

let LocationBranchService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/location-branch`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    // create multiple branch for location
    let createLocationBranchGroup = (data) => {
        return $http
            .post(AppConstants.api + `/location-branch/branchGroup`, data)
            .then((res) => {
                return res.data
            })
    };

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/location-branch/${encodeURIComponent(id)}`)
            .then((res) => {
                return res.data
            })
    }

    let updateLocationBranchGroup = (data) => {
        return $http
            .post(AppConstants.api + `/location-branch/updateBranchGroup`, data)
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        createLocationBranchGroup,
        get,
        updateLocationBranchGroup
    };

};

LocationBranchService.$inject = ['$http', '$q']

export default LocationBranchService;


// WEBPACK FOOTER //
// ./client/app/services/location-branch.service.js